/**
 * Wheel of Fortune letterboard validator.
 * Checks that the model contains the same text as the puzzle tiles.
 */
angular.module('tgaAdmin').directive('wofValidateLetterboard', () => ({
  restrict: 'A',
  require: 'ngModel',
  scope: {
    question: '<wofValidateLetterboard',
  },
  link(scope, element, attr, modelCtrl) {
    scope.$watchCollection('question.meta.positions', (positions) => {
      const tileChars = _.map(positions, 'letter').join('');
      const modelChars = _.toString(modelCtrl.$modelValue).replace(/\s/g, '');
      modelCtrl.$setValidity('letterboard', tileChars === modelChars);
    });
  },
}));
